import {actionableCard} from './card/listing-card';

const SummaryTypeEnum = Object.freeze({Pack: 1, Individual: 2, Shipping: 3});

const orderSummaryMixin = {
    data() {
        return {
            totalPrice: 0,
            gst: 0,
            totalPriceWithGst: 0,
            totalPriceWithDiscount: 0,
        };
    },

    computed:
    {
        orderSummaryItems() {
            return this.model.items;
        },

        discountPercent() {
            return this.model.discountPercent;
        },

        discountMultiplier() {
            return !this.discountPercent ? 1 : (1 - this.discountPercent);
        },

        hasDiscount() {
            return this.discountMultiplier !== 1;
        },

        taxPercent() {
            return this.model.taxPercent;
        },

        hasTax() {
            return this.model.taxPercent !== 0;
        },
    },
    methods: {
        _getTotalTaxFree() {
            const orderItems = this.orderSummaryItems;
            return orderItems.reduce((col, val) => col + val.price, 0);
        },

        _resetTotalPrice() {
            const totalWithTaxWithoutDiscount = this._getTotalTaxFree();

            const totalWithTaxAndDiscount =
                Math.round((this.discountMultiplier * totalWithTaxWithoutDiscount) * 100) / 100;

            const totalWithoutTax = (totalWithTaxWithoutDiscount / (1 + this.taxPercent)).toFixed(2);
            const totalWithoutTaxWithDiscount =
                Math.round((this.discountMultiplier * parseFloat(totalWithoutTax)) * 100) / 100;

            this.totalPrice = totalWithoutTax;
            this.gst = totalWithTaxAndDiscount - totalWithoutTaxWithDiscount;
            this.totalPriceWithGst = totalWithTaxAndDiscount;
            this.totalPriceWithDiscount = totalWithoutTaxWithDiscount;
        },

        _getOrderItems() {
            return this.orderSummaryItems.filter((i) => i.summaryType !== SummaryTypeEnum.Shipping);
        },
    },

    mounted() {
        this._resetTotalPrice();
    },
};

function initOrderSummaryComponent(app) {
    app.component('order-summary', {
        template: '#order-summary',
        mixins: [actionableCard, orderSummaryMixin],
        props: {
            model: {required: true},
            isCompact: {default: true},
            hasActions: {default: false},
            title: null,
        },
        computed: {
            isAdvertisingPlan() {
                return this.model.advertisingPlansIds.includes(this.model.selectedPack);
            },
        },
        data() {
            return {
                listing: this.model.advertOfferTerms.listing,
            };
        },
    });
}

export {
    initOrderSummaryComponent,
    orderSummaryMixin,
};
